// extracted by mini-css-extract-plugin
export default {"fullWidth":"Vh-z","hasStyledAspectRatio":"Wh-z"};